import React, { useState, useEffect, useMemo } from "react";

const API_ROOT  = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
const ALLOWED   = [1, 2, 3, 5, 7, 9, 13, 15, 16];

export default function ResolverPending() {
  const localUser = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); }
    catch { return null; }
  }, []);

  const moduleId = parseInt(localUser?.moduleId, 10);
  const empId    = parseInt(localUser?.id,       10);
  const deptId   = parseInt(localUser?.deptid,   10);

  const [complaints,  setComplaints]  = useState([]);
  const [loading,     setLoading]     = useState(false);
  const [error,       setError]       = useState("");
  const [progress,    setProgress]    = useState(null);   // { ticketId, rows }
  const [progLoading, setProgLoading] = useState(false);

  useEffect(() => {
    if (!ALLOWED.includes(moduleId)) return;
    setLoading(true);
    const params = new URLSearchParams({ moduleId, empId, deptId });
    fetch(`${API_ROOT}/api/complaints/pending-complaints?${params}`)
      .then(r => r.json())
      .then(d => setComplaints(d.data || []))
      .catch(() => setError("Failed to load complaints."))
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const showProgress = async (ticketId) => {
    setProgress({ ticketId, rows: null, error: null });
    setProgLoading(true);
    try {
      const params = new URLSearchParams({ moduleId, employeeId: empId, deptId });
      const res  = await fetch(`${API_ROOT}/api/complaints/progress/${ticketId}?${params}`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
      setProgress({ ticketId, rows: data.data || [], error: null });
    } catch (err) {
      setProgress({ ticketId, rows: [], error: err.message });
    } finally {
      setProgLoading(false);
    }
  };

  if (!ALLOWED.includes(moduleId)) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">Unauthorized access Or Session Timed out.</div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-3">
      <h3 className="ctitle">Pending Complaints</h3>

      {error   && <div className="alert alert-danger">{error}</div>}
      {loading && <div className="alert alert-info">Loading...</div>}

      {!loading && !error && complaints.length === 0 && (
        <p>No pending complaints found.</p>
      )}

      {complaints.length > 0 && (
        <div className="table-responsive">
          <table className="table table-bordered table-striped table-sm" style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
            <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
              <tr>
                <th>SNo</th>
                <th>ComplaintType</th>
                <th>ComplaintDescription</th>
                <th>Remarks</th>
                <th>AreaType</th>
                <th>HNo/Dept</th>
                <th>DOC</th>
                <th>Status</th>
                <th>ComplaintID</th>
                <th>AssignedTo</th>
                <th>Print</th>
                <th>Doc</th>
                <th>Progress</th>
              </tr>
            </thead>
            <tbody>
              {complaints.map((c, idx) => (
                <tr key={`${c.TicketID}-${idx}`}>
                  <td>{idx + 1}</td>
                  <td>{c.ComplaintCategory}</td>
                  <td style={{ whiteSpace: "normal", minWidth: 150 }}>{c.ComplaintDescription}</td>
                  <td style={{ whiteSpace: "normal", minWidth: 140 }}>{c.Description}</td>
                  <td>{c.ResiType}</td>
                  <td>{c.ResidenceID}</td>
                  <td>{c.DOCLabel}</td>
                  <td>{c.StatusLabel}</td>
                  <td>{c.TicketID}</td>
                  <td>{c.EmpName}</td>
                  <td>
                    <a
                      href={`${API_ROOT}/api/complaints/print/${c.TicketID}?moduleId=${moduleId}&employeeId=${empId}&deptId=${deptId}`}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-sm btn-outline-secondary"
                    >
                      Print
                    </a>
                  </td>
                  <td>
                    {c.SupportingDocUrl ? (
                      <a
                        href={`${API_ROOT}${c.SupportingDocUrl}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm btn-outline-secondary"
                      >
                        View
                      </a>
                    ) : (
                      <span style={{ color: "red" }}>No Doc</span>
                    )}
                  </td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => showProgress(c.TicketID)}
                    >
                      Progress
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Progress modal — matches PHP openChildWindow behaviour */}
      {progress && (
        <>
          <div
            className="modal fade show"
            style={{ display: "block" }}
            onClick={() => setProgress(null)}
          >
            <div
              className="modal-dialog modal-xl modal-dialog-scrollable"
              onClick={e => e.stopPropagation()}
            >
              <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: "#008080", color: "white" }}>
                  <h5 className="modal-title">Progress Details — Ticket #{progress.ticketId}</h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setProgress(null)}
                  />
                </div>
                <div className="modal-body">
                  {progLoading ? (
                    <p>Loading...</p>
                  ) : progress.error ? (
                    <p className="text-danger">Error: {progress.error}</p>
                  ) : !progress.rows?.length ? (
                    <p>No progress found for Ticket #{progress.ticketId}</p>
                  ) : (
                    <table className="table table-bordered table-striped table-sm" style={{ fontSize: "13px" }}>
                      <thead style={{ "--bs-table-bg": "#008080", color: "white" }}>
                        <tr>
                          <th>Progress Details</th>
                          <th>Remarks</th>
                          <th>Date</th>
                          <th>Status</th>
                          <th>Transferred To</th>
                        </tr>
                      </thead>
                      <tbody>
                        {progress.rows.map((p, i) => (
                          <tr key={i}>
                            <td>{p.ProgressDetails || "-"}</td>
                            <td>{p.Remark}</td>
                            <td>{p.DOWPLabel}</td>
                            <td>{p.StatusLabel}</td>
                            <td>{p.EmployeeID === 36 ? "" : p.Resolver}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setProgress(null)}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
    </div>
  );
}
